import angular from 'angular';

import component from './preferences-questions-overview.component';

const PreferencesQuestionsOverview = angular
    .module('control-room.app-settings.components.preferences-details.components.preferences-questions-overview', [])
    .component('crPreferencesQuestionsOverview', component);

export default PreferencesQuestionsOverview;
